import { render, staticRenderFns } from "./ui-order-list.vue?vue&type=template&id=df053a5e&scoped=true&"
import script from "./ui-order-list.vue?vue&type=script&lang=js&"
export * from "./ui-order-list.vue?vue&type=script&lang=js&"
import style0 from "./ui-order-list.vue?vue&type=style&index=0&id=df053a5e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df053a5e",
  null
  
)

export default component.exports